<template><div><div class="d-ba d-bar-500 d-py-200 d-mbs-400 d-ta-center d-fc-muted d-headline--xxl">
  <dt-empty-state
    :size="300"
    header-text="TBD"
    class="d-w100p"
  >
    <template #icon="{ iconSize }">
      <dt-icon name="box" :size="iconSize" class="d-fc-tertiary" />
    </template>
  </dt-empty-state>
</div>
</div></template>


